import React, { Component } from "react";
import ReactHtmlParser from 'react-html-parser';
import {FeedingController} from '../controllers/Feeding';
import '../styles/feeding.css';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label
} from "reactstrap";

export default class CustomModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      milkFrequency: null,
      breastData: {
        breast_feeding: null,
        breast_frequency: null,
      }
    }
  }

  onbBreastFedChange = (e) => {
    const breastData = this.state.breastData;
    const option= e.target.value;
    const response = FeedingController.showMilkFrequency(option, this.props.translation);
    breastData.breast_feeding = option;

    this.setState({ milkFrequency: response, breastData: breastData });
  }

  onBreastFrequencyChange= (e) => {
    const breastData = this.state.breastData;
    breastData.breast_frequency =  e.target.value;
    this.setState({breastData: breastData });
  }

  render() {
    const { toggle, onUpdate, onSave, Child, translation } = this.props;
    return (
        <div className="col-md-12 col-sm-12 col-xs-12">
          <Modal isOpen={true} toggle={toggle} style = {{padding: "0px", margin: "0px", marginTop: "195px"}}>
            <div className="modal-dialog" style = {{padding: "0px", margin: "0px"}}>
              <div className="col-md-12 col-sm-12 col-xs-12" style = {{padding: "0px", margin: "0px"}}>
                <div className="modal-content" style={{marginTop: "",borderRadius: "0px",backgroundColor: "hsl(120, 50%, 40%)"}}>
                  <div className="modal-header">
                    <div className="modal-title" style={{textAlign: "center"}}>{translation['feeding_practice_breastfeed_option_label']}</div>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <select id="breast_feeding" name="breast_feeding" className="form-control" onChange={this.onbBreastFedChange}>
                        <option value="">{translation['feeding_practice_breastfeed_empty_option']}</option>
                        <option value={translation['yes_option']}>{translation['yes_option']}</option>
                        <option value={translation['no_option']}>{translation['no_option']}</option>
                      </select>
                      <span id="breast_feeding_error"></span>
                    </div>
                    {this.state.milkFrequency !== null ? (
                    <div id="breast_frequency_div">
                      <div className="form-group">
                      <label className="breast_feeding_error form-control-label text-center">{translation['feeding_practice_breastfeed_frequency_label']}</label><br/>
                        <select name="breast_frequency" className="form-control" id="breast_frequency" onChange = {this.onBreastFrequencyChange}>
                          {ReactHtmlParser(this.state.milkFrequency)}
                        </select>
                      </div>
                    </div>
                    ) : null}
                    <div className="modal-footer">
                      <button  onClick = {toggle} style={{marginRight: "20px",height: "30px",width: "70px"}}>{translation['feeding_practice_breastfeed_cancel_button']}</button>
                      <button onClick={() => onSave(this.state.breastData)} style={{height: "30px",width: "70px"}} id="breast_feeding_frequency">{translation['feeding_practice_breastfeed_save_button']}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            </Modal>   
          {/* </div> */}
        </div>
    );
  }
}